import {
  fetchHomeList,
  fetchResultList,
  fetchBizoppDetail,
  fetchCategoryList,
  fetchPlatformList,
  fetchNewBizoppList,
  bizoppGiveUp,
  bizoppPickIn,
  getAbnormalTags,
  fetchsAppealApply,
  getStrategyTag,
} from '@/api'
import { get } from 'lodash-es'
import { BIZOPP_IN_PROCESS_STATUS, BIZOPP_SUCCESS_STATUS, BIZOPP_FAILED_STATUS } from '@/consts'
import { getDiagnosisDetail } from '@/pages-v2/ShopDetail/components/Diagnosis/service.js'

function showStatusRank(showStatus, showRank, status, rank) {
  if (showStatus) {
    return {
      status,
    }
  }
  if (showRank) {
    return {
      rank,
    }
  }
}
export default {
  // 获取首页list
  getHomeList({ commit, state, rootGetters }, params) {
    let status = []
    let paramsList = []
    // let isHigherPrice = null
    // try {
    //   isHigherPrice = get(params, 'isHigherPrice.length') === 0 ? undefined : params.isHigherPrice[0]
    // } catch (e) {
    //   console.warn(e)
    // }
    status =
      get(params, 'status.length', 0) > 0
        ? params.status.map(item => {
            return item.split(':')[1]
          })
        : []
    const showStatus = get(params, 'status.length') !== 0
    const showRank = get(params, 'rank.length') !== 0
    const rankSataus = showStatusRank(showStatus, showRank, status)
      ? showStatusRank(showStatus, showRank, status)
      : {}
    paramsList = {
      ...rootGetters.areaGroup,
      ...params,
      ...rankSataus,
      // abnormalTags: get(params, 'abnormalTags.length') === 0 ? [-1] : params.abnormalTags,
      // isHigherPrice
    }

    return fetchHomeList(paramsList).then(res => {
      commit('updateHomeList', res.data)
      return res.data
    })
  },
  // 获取搜索结果页list
  getResultList({ commit, state, rootGetters }, params) {
    let status = []
    let paramsList = []
    let isHigherPrice = null
    try {
      isHigherPrice =
        get(params, 'isHigherPrice.length') === 0 ? undefined : params.isHigherPrice[0]
    } catch (e) {
      console.warn(e)
    }
    status =
      get(params, 'status.length', 0) > 0
        ? params.status.map(item => {
            return item.split(':')[1]
          })
        : []
    const showStatus = get(params, 'status.length') !== 0
    const showRank = get(params, 'rank.length') !== 0
    const rankSataus = showStatusRank(showStatus, showRank, status, params.rank)
      ? showStatusRank(showStatus, showRank, status, params.rank)
      : {}
    paramsList = {
      ...rootGetters.areaGroup,
      ...params,
      ...rankSataus,
      // abnormalTags: get(params, 'abnormalTags.length') === 0 ? [-1] : params.abnormalTags,
      isHigherPrice,
    }
    return fetchResultList(paramsList).then(res => {
      commit('updateHomeListAll', res.data)
      return res.data
    })
  },
  // 获取业务策略数据放到filter筛选项里
  getStrategyTag({ commit, state }, params) {
    return getStrategyTag(params).then(res => {
      if (res && res.data && res.data.strategyTag) {
        commit('updateStrategyTag', res.data.strategyTag)
        return res.data.strategyTag
      }
    })
  },
  // loadMore搜索结果页list全部列表数据
  loadMoreResultListAll({ commit, state, rootGetters }, params) {
    let status = []
    let paramsList = []
    let isHigherPrice = null
    try {
      isHigherPrice =
        get(params, 'isHigherPrice.length') === 0 ? undefined : params.isHigherPrice[0]
    } catch (e) {
      console.warn(e)
    }
    status =
      get(params, 'status.length') > 0
        ? params.status.map(item => {
            return item.split(':')[1]
          })
        : []
    const showStatus = get(params, 'status.length') !== 0
    const showRank = get(params, 'rank.length') !== 0
    const rankSataus = showStatusRank(showStatus, showRank, status, params.rank)
      ? showStatusRank(showStatus, showRank, status, params.rank)
      : {}
    paramsList = {
      ...rootGetters.areaGroup,
      ...params,
      ...rankSataus,
      // abnormalTags: get(params, 'abnormalTags.length') === 0 ? [-1] : params.abnormalTags,
      isHigherPrice,
    }
    return fetchResultList(paramsList).then(res => {
      const { total, list } = res.data
      const nList = { total, list: state.homeListAll.list.concat(list) }
      commit('updateHomeListAll', nList)
      return nList
    })
  },
  // loadMore首页list
  loadMoreHomeList({ commit, state, rootGetters }, params) {
    let paramsList = []
    let status = []
    // let isHigherPrice = null
    // try {
    //   isHigherPrice = get(params, 'isHigherPrice.length') === 0 ? undefined : params.isHigherPrice[0]
    // } catch (e) {
    //   console.warn(e)
    // }
    status =
      get(params, 'status.length') > 0
        ? params.status.map(item => {
            return item.split(':')[1]
          })
        : []
    const showStatus = get(params, 'status.length') !== 0
    const showRank = get(params, 'rank.length') !== 0
    const rankSataus = showStatusRank(showStatus, showRank, status, params.rank)
      ? showStatusRank(showStatus, showRank, status, params.rank)
      : {}
    paramsList = {
      ...rootGetters.areaGroup,
      ...params,
      ...rankSataus,
      // abnormalTags: get(params, 'abnormalTags.length') === 0 ? [-1] : params.abnormalTags,
      // isHigherPrice
    }
    return fetchHomeList(paramsList).then(res => {
      const { total, list } = res.data
      const nList = { total, list: state.homeList.list.concat(list) }
      commit('updateHomeList', nList)
      return nList
    })
  },
  // 获取首页全部列表数据
  getHomeListAll({ commit, state, rootGetters }, params) {
    let status = []
    let paramsList = []
    // let isHigherPrice = null
    // try {
    //   isHigherPrice = get(params, 'isHigherPrice.length') === 0 ? undefined : params.isHigherPrice[0]
    // } catch (e) {
    //   console.warn(e)
    // }
    status =
      get(params, 'status.length', 0) > 0
        ? params.status.map(item => {
            return item.split(':')[1]
          })
        : []
    const showStatus = get(params, 'status.length') !== 0
    const showRank = get(params, 'rank.length') !== 0
    const rankSataus = showStatusRank(showStatus, showRank, status, params.rank)
      ? showStatusRank(showStatus, showRank, status, params.rank)
      : {}
    paramsList = {
      ...rootGetters.areaGroup,
      ...params,
      ...rankSataus,
      // abnormalTags: get(params, 'abnormalTags.length') === 0 ? [-1] : params.abnormalTags,
      // isHigherPrice
    }
    return fetchHomeList(paramsList).then(res => {
      commit('updateHomeListAll', res.data)
      return res.data
    })
  },
  // loadMore首页全部列表数据
  loadMoreHomeListAll({ commit, state, rootGetters }, params) {
    let status = []
    let paramsList = []
    let isHigherPrice = null
    try {
      isHigherPrice =
        get(params, 'isHigherPrice.length') === 0 ? undefined : params.isHigherPrice[0]
    } catch (e) {
      console.warn(e)
    }
    status =
      get(params, 'status.length') > 0
        ? params.status.map(item => {
            return item.split(':')[1]
          })
        : []
    const showStatus = get(params, 'status.length') !== 0
    const showRank = get(params, 'rank.length') !== 0
    const rankSataus = showStatusRank(showStatus, showRank, status, params.rank)
      ? showStatusRank(showStatus, showRank, status, params.rank)
      : {}
    paramsList = {
      ...rootGetters.areaGroup,
      ...params,
      ...rankSataus,
      // abnormalTags: get(params, 'abnormalTags.length') === 0 ? [-1] : params.abnormalTags,
      isHigherPrice,
    }
    return fetchHomeList(paramsList).then(res => {
      const { total, list } = res.data
      const nList = { total, list: state.homeListAll.list.concat(list) }
      commit('updateHomeListAll', nList)
      return nList
    })
  },
  // 获取首页全部列表数据
  getHomeListPriority({ commit, state, rootGetters }, params) {
    let status = []
    let paramsList = []
    let isHigherPrice = null
    try {
      isHigherPrice =
        get(params, 'isHigherPrice.length') === 0 ? undefined : params.isHigherPrice[0]
    } catch (e) {
      console.warn(e)
    }
    status =
      get(params, 'status.length', 0) > 0
        ? params.status.map(item => {
            return item.split(':')[1]
          })
        : []
    const showStatus = get(params, 'status.length') !== 0
    const showRank = get(params, 'rank.length') !== 0
    const rankSataus = showStatusRank(showStatus, showRank, status, params.rank)
      ? showStatusRank(showStatus, showRank, status, params.rank)
      : {}
    paramsList = {
      ...rootGetters.areaGroup,
      ...params,
      ...rankSataus,
      // abnormalTags: get(params, 'abnormalTags.length') === 0 ? [-1] : params.abnormalTags,
      isHigherPrice,
    }
    return fetchHomeList(paramsList).then(res => {
      commit('updateHomeListPriority', res.data)
      return res.data
    })
  },
  // loadMore首页全部列表数据
  loadMoreHomeListPriority({ commit, state, rootGetters }, params) {
    let status = []
    let paramsList = []
    let isHigherPrice = null
    try {
      isHigherPrice =
        get(params, 'isHigherPrice.length') === 0 ? undefined : params.isHigherPrice[0]
    } catch (e) {
      console.warn(e)
    }
    status =
      get(params, 'status.length') > 0
        ? params.status.map(item => {
            return item.split(':')[1]
          })
        : []
    const showStatus = get(params, 'status.length') !== 0
    const showRank = get(params, 'rank.length') !== 0
    const rankSataus = showStatusRank(showStatus, showRank, status, params.rank)
      ? showStatusRank(showStatus, showRank, status, params.rank)
      : {}
    paramsList = {
      ...rootGetters.areaGroup,
      ...params,
      ...rankSataus,
      // abnormalTags: get(params, 'abnormalTags.length') === 0 ? [-1] : params.abnormalTags,
      isHigherPrice,
    }
    return fetchHomeList(paramsList).then(res => {
      const { total, list } = res.data
      const nList = { total, list: (state.homeListPriority || []).list.concat(list || []) }
      commit('updateHomeListPriority', nList)
      return nList
    })
  },
  // 获取商机详情
  getBizoppDetail({ commit, state }, params) {
    const shopId = params.shopId
    if (state.details[shopId]) {
      return state.details[shopId]
    } else {
      return fetchBizoppDetail({
        shopId,
      }).then(res => {
        commit('updateBizoppDetail', {
          [shopId]: res.data,
        })
        return res.data
      })
    }
  },
  // 获取商机品类list
  getCategoryList({ commit, state }, params) {
    if (state.categoryList.length > 0) {
      return state.categoryList
    }
    return fetchCategoryList().then(res => {
      const list = Object.keys(res.data).map(i => {
        return {
          label: res.data[i],
          value: i,
        }
      })
      commit('updateCategoryList', list)
      return list
    })
  },
  getPlatformList({ commit, state }, params) {
    if (state.platformList.length > 0) {
      return state.platformList
    }
    return fetchPlatformList().then(res => {
      const { hand = {}, system = {} } = res.data
      const handList = Object.keys(hand).map(i => {
        return {
          label: hand[i],
          value: +i,
        }
      })
      const systemList = Object.keys(system).map(i => {
        return {
          label: system[i],
          value: +i,
        }
      })
      commit('updatePlatformList', {
        hand: handList,
        system: systemList,
      })
      return {
        hand: handList,
        system: systemList,
      }
    })
  },
  // 获取新增商机列表
  getNewBizoppList({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      fetchNewBizoppList({
        // 新增商机
        type: 1,
        ...params,
      })
        .then(res => {
          const list = res.data
          // status区分成功、提交中、失败
          switch (params.status) {
            case BIZOPP_IN_PROCESS_STATUS:
              commit('updateInProcessList', list)
              break
            case BIZOPP_SUCCESS_STATUS:
              commit('updateSuccessList', list)
              break
            case BIZOPP_FAILED_STATUS:
              commit('updateFailedList', list)
              break
            default:
              break
          }
          resolve(list)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // loadMore新增商机列表
  loadMoreNewBizoppList({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      fetchNewBizoppList({
        // 新增商机
        type: 1,
        ...params,
      })
        .then(res => {
          const { total, list } = res.data
          // status区分成功、提交中、失败
          switch (params.status) {
            case BIZOPP_IN_PROCESS_STATUS:
              commit('updateInProcessList', {
                total,
                list: state.inProcessList.list.concat(list),
              })
              break
            case BIZOPP_SUCCESS_STATUS:
              commit('updateSuccessList', {
                total,
                list: state.successList.list.concat(list),
              })
              break
            case BIZOPP_FAILED_STATUS:
              commit('updateFailedList', {
                total,
                list: state.failedList.list.concat(list),
              })
              break
            default:
              break
          }
          resolve(list)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  giveUpBizopp({ commit, state }, params) {
    return bizoppGiveUp(params).then(res => {
      return res.data
    })
  },
  pickUpBizopp({ commit, state }, params) {
    return bizoppPickIn(params).then(res => {
      return res.data
    })
  },
  async getGiveUpReason({ commit, state }, params) {
    const res = await getAbnormalTags(params)
    return res.data
  },
  getAppealApply({ commit, state }, params) {
    return fetchsAppealApply(params).then(res => {
      return res.data
    })
  },
  async getDiagnosis({ commit, state }, params = {}) {
    const { callback, ...LParams } = params || {}
    const data = await getDiagnosisDetail(LParams).catch(() => {
      callback && callback()
    })
    callback && callback(data)
    commit('updateDiagnosis', {
      shopId: params.shopId,
      data,
    })
  },
}
